import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import menuConfig from '../../../../config/menu.config';
import DrawerHeaderStyled from '../../../../../layout/MainLayout/NewDrawer/DrawerHeader/DrawerHeaderStyled';
import PrimaryLogo from '../../../../../assets/main-logo/ACT.360-Logo.svg';
import SecondaryLogo from '../../../../../assets/main-logo/New-Logo.svg';
import { memo, useCallback, useMemo } from 'react';

const SidebarHeader = ({
  open = false,
  handleDrawerToggle,
  isInvestigator = false,
  matchDownMD = false
}) => {
  const theme = useTheme();
  const { activeSmallScreenMenu } = useSelector(state => state.menu);

  const hasSubChildren = useMemo(() => {
    if (!activeSmallScreenMenu?.length) return false;
    const childItem = menuConfig.children?.find(op => op.id === activeSmallScreenMenu[0]);
    return Boolean(childItem?.subChildren);
  }, [activeSmallScreenMenu]);

  const handleLogoClick = useCallback(() => {
    if (!isInvestigator) {
      handleDrawerToggle();
    }
  }, [isInvestigator, handleDrawerToggle]);

  const shouldShowPrimaryLogo = (matchDownMD && !hasSubChildren) || (!matchDownMD && !open);

  const logoProps = {
    onClick: shouldShowPrimaryLogo ? handleLogoClick : undefined,
    className: shouldShowPrimaryLogo && !isInvestigator ? 'cursor-pointer' : '',
    width: shouldShowPrimaryLogo ? "40px" : "210px",
    src: shouldShowPrimaryLogo ? PrimaryLogo : SecondaryLogo,
    alt: "Logo",
    style: {
    objectFit: 'contain',
    width: shouldShowPrimaryLogo ? "40px" : "210px",
    height: 'auto',
    transition: 'width 0.3s ease-in-out',
    minWidth: '40px',
    maxWidth: '210px'
  }
  };

  return (
    <DrawerHeaderStyled
      className="divider-border"
      theme={theme}
      open={open}
      isInvestigator={isInvestigator}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <img {...logoProps} style={{ objectFit: 'contain' }} />
      </Stack>
    </DrawerHeaderStyled>
  );
};

SidebarHeader.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func.isRequired,
  isInvestigator: PropTypes.bool,
  matchDownMD: PropTypes.bool
};

export default memo(SidebarHeader);
